const prepaidInventoryVirtualTabStyle = {

};

export default prepaidInventoryVirtualTabStyle;
